export default __webpack_public_path__ + "static/media/Nomination_and_Remuneration_Policy_2.f22fb2f8.pdf";